import { render, staticRenderFns } from "./ReplyPendingList.vue?vue&type=template&id=06543d94&scoped=true"
import script from "./ReplyPendingList.vue?vue&type=script&lang=js"
export * from "./ReplyPendingList.vue?vue&type=script&lang=js"
import style0 from "./ReplyPendingList.vue?vue&type=style&index=0&id=06543d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_babel-core@7.0.0-bridge.0_@babel+core@7.29._923e00a32cb73abfd4273dbca1fa1c77/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06543d94",
  null
  
)

export default component.exports